//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VtkRenderer from "./VtkRenderer";
import TheMapTrajectoryView from "./TheMapTrajectoryView";
import TheVsMDView from "./TheVsMDView";
import TheInformationView from "./TheInformationView";

import { CesHttpClient, Continuum } from "../CesHttpClient";

import { mapState, mapActions } from "vuex";

export default {
  props: {
    curtainGridC: {
      type: Continuum,
      default: null
    },
    plannedLogData: {
      type: Continuum,
      default: null
    },
    imageLog: {
      type: Continuum,
      default: null
    },
    httpClient: {
      type: CesHttpClient,
      default: null
    },
    chartDefinition: {
      type: Object,
      default: () => { }
    }
  },
  data: function () {
    return {
      title: "Trajectory View",
      // active: (process.env.NODE_ENV === 'development') ? 2 : 0,
      active: 2,
    };
  },
  components: {
    TheInformationView,
    VtkRenderer,
    TheMapTrajectoryView,
    TheVsMDView
  },
  computed: {
    ...mapState({
      preferences: state => state.preferences.global,
      logPlotData: state => state.drilling.logPlotData,
      geometryForVtk: state => state.curtains.geometryForVtk,
      textureForVtk: state => state.curtains.textureForVtk,
    })
  },
  watch: {
    active: function() {
      console.log("active tab = " + this.active)
    }
  }
};
